import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import i18n from '@/i18n'
import Layout from '../layout.vue'
import Index from './index.vue'
import QuestionnaireList from './questionnaire/list.vue'
import QuestionnaireEditor from './questionnaire/editor.vue'
import QuestionList from './question/list.vue'
import ScoreScaleList from './scoreScaleSetting/list.vue'
import BlankLayout from '../../layout/blankLayout.vue'

const basePath = '/v-admin/questionnaire-management'
const i18nPrefix = 'admin.company.questionnaireManagement'

const QuestionnaireEditRoute = {
  path: `${basePath}/questionnaire`,
  redirect: `${basePath}/questionnaire/list`,
  component: BlankLayout,
  meta: {
    breadcrumb: { labelI18nKey: `${i18nPrefix}.tab.questionnaire` }
  },
  children: [
    {
      path: `${basePath}/questionnaire/edit/:questionnaireId`,
      component: QuestionnaireEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.questionnaire.edit`,
        isEditMode: true
      }
    },
    {
      path: `${basePath}/questionnaire/view/:questionnaireId`,
      component: QuestionnaireEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.questionnaire.view`,
        isViewMode: true
      }
    },
    {
      path: `${basePath}/questionnaire/add`,
      component: QuestionnaireEditor,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.questionnaire.add`,
        isEditMode: false
      }
    }
  ]
}

export const tabMenuRoute = {
  path: basePath,
  redirect: `${basePath}/questionnaire/list`,
  component: Index,
  meta: {
    titleI18nKey: `${i18nPrefix}.title.management`,
    breadcrumb: { hidden: true }
  },
  children: [
    {
      path: `${basePath}/questionnaire/list`,
      component: QuestionnaireList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.management`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tab.questionnaire`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tab.questionnaire` }
      }
    },
    {
      path: `${basePath}/question/list`,
      component: QuestionList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.management`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tab.question`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tab.question` }
      }
    },
    {
      path: `${basePath}/score-scale-setting/list`,
      component: ScoreScaleList,
      meta: {
        titleI18nKey: `${i18nPrefix}.title.management`,
        tabMenuLabelI18nKey: `${i18nPrefix}.tab.scoreScale`,
        breadcrumb: { labelI18nKey: `${i18nPrefix}.tab.scoreScale` }
      }
    }
  ]
}

export default {
  path: basePath,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: {
      strict: false, // any 中是否全部满足
      isMatchAnd: true, // any 的子数组中是否全部满足
      any: [
        ['PERM_EDIT_INTERVIEW_FORM', 'PREMIUM_INTERVIEW_SCHEDULING'],
        ['PREMIUM_INVITE_HM_REVIEW', 'PERM_INVITE_HM_REVIEW']
      ]
    },
    titleI18nKey: `${i18nPrefix}.title.management`,
    menu: {
      get label () {
        return i18n.t(`${i18nPrefix}.menu`)
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    tabMenuRoute,
    QuestionnaireEditRoute
  ]
}
